import React from 'react';
import { User } from 'lucide-react';
import FlatDashboardCard from '@/components/ui/FlatDashboardCard';
import CardHeader from '@/components/ui/CardHeader';
import PersonalInformationForm from './PersonalInformationForm';

const PersonalInformationSection = () => {
  return (
    <FlatDashboardCard>
      <CardHeader
        title="Personal Information"
        icon={User}
        variant="green"
        className="mb-6"
      />
      <PersonalInformationForm />
    </FlatDashboardCard>
  );
};

export default PersonalInformationSection;
